import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ComponentsSelect from '../types/ComponentsSelect';
import InputBox from '../inputs/InputBox';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { validateAndDispatch } from '../../helpers/form';
import { createSelector } from 'reselect';
import { ModalActions } from '../../actions/modal';
import { ElementTypeActions } from '../../actions/elementType';
import { CreateElementTypePropertyActions } from '../../actions/forms/createElementTypeProperty';
import { Map } from 'immutable';

import { getComponent } from '../types/Components';
// import './CreateProjectButton.css';

// const currentElementTypeIdSelector = (state, props) => {
//   const tabs = state.projectTabs.get('tabs');
//   const activeTabId = state.projectTabs.getIn(['tabsOrder', state.projectTabs.get('activeTabIndex')]);
//   const currentElementTypeId = activeTabId ? state.projectTabs.getIn(['tabs', activeTabId.toString()]).get('id') : null;
//   return currentElementTypeId ? currentElementTypeId.toString() : null;
// }

import {
  modalSelector,
} from '../../reducers/modal';

const projectIdSelector = (state) => state.projects.get('currentProjectId');
const elementTypesSelector = (state, props) => state.elementTypes.get('elementTypes');

const getCurrentEleTypeId = (modal) => {
  return modal.getIn(['options', 'currentElementTypeId'], null);
}

const createElementTypePropertyFormSelector = (state) => {
  const selector = formValueSelector('createElementTypeProperty');
  return selector(
    state,
    'propType',
    'propName',
    'propValue',
    'propHelpText',
    'propComment',
    'displayValue',
    'typeOptions',
    'readOnly'
  );
};

const CreateElementTypePropertyModalSelector = createSelector(
  [
    projectIdSelector,
    modalSelector,
    elementTypesSelector,
    createElementTypePropertyFormSelector,
  ],
  (
    projectId,
    modal,
    elementTypes,
    createElementTypePropertyForm
  ) => ({
    projectId,
    currentElementTypeId: getCurrentEleTypeId(modal),
    elementTypes,
    fields: createElementTypePropertyForm,
    initialValues: {
      propType: 'string',
      displayValue: true,
    },
  })
);


@connect(CreateElementTypePropertyModalSelector)
@reduxForm({
  form: 'createElementTypeProperty',
  destroyOnUnmount: true
})
@connect(state => ({
  notifications: state.createElementTypePropertyForm.get('notifications')
}))
export default class CreateElementTypePropModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    elementTypes: PropTypes.instanceOf(Map),
  }

  onClose() {
    const { dispatch } = this.props;
    dispatch(ModalActions.hideModal());
  }

  onBack() {
    const { dispatch } = this.props;
    dispatch(ModalActions.backModal());
  }

  dismissNotices() {
    const { dispatch } = this.props;
    dispatch(CreateElementTypePropertyActions.dismissNotices());
  }

  submit = (values, dispatch) => {
    const {
      fields: {
        propType,
        propName,
        propValue,
        propHelpText,
        propComment,
        displayValue,
        typeOptions,
        readOnly,
      },
      reset,
      elementTypes,
      currentElementTypeId
    } = this.props;

    const currElementType = elementTypes.get(currentElementTypeId);

    const newProperty = {
      propName,
      defaultMeta: {
        _type: propType,
        _default: propValue,
        _display: displayValue,
        _order: 0,
        _helptext: propHelpText,
        _comment: propComment,
        _typeOptions: typeOptions,
        _readOnly: readOnly,
      },
    };

    const validation = {
      propName: [{ rule: 'required', label: 'property name' }],
      propType: [{ rule: 'required', label: 'property type' }],
    };

    const action = ElementTypeActions.createElementTypeProperty(currElementType, newProperty);

    return validateAndDispatch(
      dispatch,
      action,
      validation,
      values
    ).then(() => {
      reset();
    });
  }

  renderTypeComponent() {
    const {
      fields: {
        propType,
        propName,
        propValue,
      },
      dispatch,
    } = this.props;

    if (!propType) {
      return <div />; // propertyValue = 'string';
    }

    const TypeComponent = getComponent(propType);
    const propertyName = propName || null;

    return (<Field
      name="propValue"
      component={TypeComponent.designer}
      form="createElementTypeProperty"
      uid="createElementTypeProperty"
      wrapperClassName="form-group row mb-2"
      labelClassName="col-sm-3 col-form-label"
      containerClassName="col-sm-9"
      propertyKey={propertyName}
      value={propValue}
      dispatch={dispatch}
    />);
  }

  render() {
    const {
      dispatch,
      handleSubmit,
      submitting,
    } = this.props;

    return (
      <div className="fs-modal-content">
        <h4>Create Element Type Property</h4>
        <form>
          <div className="modal-form-wrapper">
            <Field
              component={InputBox}
              autoFocus
              name="propName"
              className="form-control"
              wrapperClassName="form-group row mb-2"
              labelClassName="col-sm-3 col-form-label"
              containerClassName="col-sm-9"
              label="Property Name"
              placeholder="Property Name"
              small="Enter a name for the new property."
            />
            <div className="form-group row mb-2">
              <label htmlFor="propType" className="col-sm-3 col-form-label">Type</label>
              <Field
                component={ComponentsSelect}
                name="propType"
                field="propType"
                containerClassName="col-sm-9"
                formName="createElementTypeProperty"
                dispatch={dispatch}
              />
            </div>
            {this.renderTypeComponent()}
            <div className="form-group row mb-2">
              <label htmlFor="propertyHelpText" className="col-sm-3 col-form-label">Help Text</label>
              <div className="col-sm-9">
                <Field
                  component="input"
                  type="text"
                  name="propHelpText"
                  className="form-control"
                  id="propertyHelpTextInput"
                  ref="propertyHelpText"
                  placeholder="Property Help Text"
                />
              </div>
            </div>
            <div className="form-group row mb-2">
              <label htmlFor="propertyComment" className="col-sm-3 col-form-label">Comment</label>
              <div className="col-sm-9">
                <Field
                  component="textarea"
                  name="propComment"
                  className="form-control"
                  id="propertyCommentInput"
                  ref="propertyComment"
                  placeholder="Property Comment"
                />
              </div>
            </div>
            <div className="form-group row mb-2">
              <label className="col-sm-3 col-form-label">Display</label>
              <div className="col-sm-9">
                <Field
                  className="mt-2"
                  name="displayValue"
                  ref="displayValue"
                  component="input"
                  type="checkbox"
                />
              </div>
            </div>
            <div className="form-group row mb-2">
              <label className="col-sm-3 col-form-label">Read Only</label>
              <div className="col-sm-9">
                <Field
                  className="mt-2"
                  name="readOnly"
                  ref="readOnly"
                  component="input"
                  type="checkbox"
                />
              </div>
            </div>
          </div>
          <div className="modal-form-button-wrapper">
            <button
              className="btn btn-primary modal-submit-btn"
              onClick={handleSubmit(this.submit)}
              disabled={submitting}
            >
              {submitting && <i className="fa fa-cog fa-spinner fa-spin"></i>} Create
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateElementTypePropertyModal.js